import { useMemo } from 'react';

export const useRequireValidationRule = () => {
  const requireValidationRule = useMemo(() => {
    return [{ type: 'required' }];
  }, []);

  return requireValidationRule;
};
